import client from '/src/services/client.js';
export default {
    generate : (bot_id, messages) => client.post(`bot/${bot_id}/ai-builder/generate`, { messages })
}
